/**
 * Light wrapper for loading youtube player API.
 *
 * Docs: https://developers.google.com/youtube/iframe_api_reference
 */
import { loadScript } from '@front-app/util/loader';

const IFRAME_API_SRC = 'https://www.youtube.com/iframe_api';

let promisedYoutube: Promise<typeof YT>;

export const getYoutube = (): Promise<typeof YT> => {
	if (promisedYoutube) {
		return promisedYoutube;
	}
	promisedYoutube = new Promise((resolve) => {
		loadScript(IFRAME_API_SRC);
		window.onYouTubeIframeAPIReady = () => {
			resolve(YT);
		};
	});
	return promisedYoutube;
};
